export default "__VITE_ASSET__5pRrniCv__"